import { Button } from "common/button"
import { Text } from "common/text"
import styled from 'styled-components'
import { useCreateTeacherForm } from "../../hook/useCreateTeacherForm"

export const Contract = () => {
    const {contract} = useCreateTeacherForm()
    const {methods} = contract

    return (
        <StyleContract>
            <Text>Hợp đồng CTV</Text>
            {contract?.value ? (
                <div className="wrapper-contract-active">
                    <Text as="a" target="_blank" href={contract?.value}>{contract?.value}</Text>
                    <div className="wrapper-contract-active--remove" onClick={methods?.onClear}>X</div>
                </div>
            ) : (
                <div className="wrapper-contract">
                    <input 
                        title="" type='file' 
                        accept=".pdf,application/pdf,.docx,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                        onChange={e => methods.onUpload(e, 'contract')}
                        className='contract-upload-image'
                    />
                    <img 
                        src="/img/upload-file.png"
                        alt="image"
                    />
                    <Button appearance='secondary'>
                        Chọn file
                    </Button>
                    <div className="contract-desc">
                        <Text color="#00000073" className="contract-desc-item">Tải xuống mẫu hợp đồng <Text color="#3264FF" className="download-link" onClick={methods?.onDownload}>tại đây</Text>, điền đủ và đúng thông tin theo mẫu.</Text>
                        <Text color="#00000073" className="contract-desc-item">Chỉ nhận file có định dạng .doc, .docx, .pdf và dung lượng dưới 3MB.</Text>
                    </div>
                </div>
            )}
        </StyleContract>
    )
}

const StyleContract = styled.div`
    .wrapper-contract {
        position: relative;
        margin-top: 8px;
        width: 450px;
        height: 207px;
        opacity: 1;
        gap: 20px;
        border-radius: 2px;
        border-width: 1px;
        border-style: dashed;
        border-color: #D9D9D9;
        background: #FAFAFA;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        & img {
            width: 44px;
            height: 57px;
        }

        &-active {
            position: relative;
            margin-top: 8px;
            width: fit-content;
            height: fit-content;
            opacity: 1;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            padding: 16px;
            gap: 8px;
            border-radius: 2px;
            border-width: 1px;
            border-style: dashed;
            border-color: #D9D9D9;
            background: #FAFAFA;
            cursor: pointer;

            &--remove { 
                position: absolute;
                top: 4px;
                right: 4px;
                cursor: pointer;
            }
        }
    }
    .contract-desc {
        display: flex;
        flex-direction: column;
        &-item {
            display: list-item;
        }

        .download-link {
            cursor: pointer;
        }
    }
    .contract-upload-image {
        width: 100%;
        height: 70%;
        opacity: 0;
        position: absolute;
        cursor: pointer;
        top: 0;
    }
`